import AuthenticatedResource from 'resources/AuthenticatedResource';

export default class VersionRollbackResource extends AuthenticatedResource {
  static urlRoot = '/admin/version_rollbacks';

  pk() {
    return 'version_rollback';
  }
}